import React from 'react';
import { Box, Container, Heading, Text, VStack, HStack, SimpleGrid, Image } from '@chakra-ui/react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { LazyVideo } from './LazyVideo';
import { videoTestimonial, writtenTestimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <Box as="section" className="defer-paint" py={{
    base: 14,
    md: 20
  }} bg="rgba(16, 16, 16, 0.6)" data-id="element-37" data-mp="1d24fd9z4u4wi">
      <Container maxW="container.xl" data-id="element-38" data-mp="1i2inst4nbgv2">
        <VStack spacing={{
        base: 10,
        md: 14
      }} data-id="element-39" data-mp="1416bcrop1xdx">
          <ScrollReveal data-id="element-40" data-mp="142hlracna3e0">
            <VStack spacing={3} textAlign="center" data-id="element-41" data-mp="1439ac17tr0us">
              <Heading as="h2" fontSize={{
              base: '2xl',
              md: '4xl'
            }} color="white" fontWeight="black" lineHeight="1.2" textShadow="0 0 28px rgba(232, 99, 26, 0.3)" data-id="element-42" data-mp="181zznm61te7c">
                Experiencias compartidas por nuestros clientes
              </Heading>
              <Text fontSize={{
              base: 'sm',
              md: 'md'
            }} color="gray.400" maxW="600px" data-id="element-43" data-mp="2q1q22nzbpqca">
                Personas que decidieron acercarse y contar cómo vivieron su
                consulta.
              </Text>
            </VStack>
          </ScrollReveal>

          <SimpleGrid columns={{
          base: 1,
          lg: 12
        }} spacing={{
          base: 10,
          lg: 10
        }} w="full" alignItems="start" data-id="element-44" data-mp="27458x4pj05lv">
            {/* Featured video testimonial */}
            <Box gridColumn={{
            lg: 'span 5'
          }} data-id="element-45" data-mp="2h3w3f6e36kly">
              <ScrollReveal data-id="element-46" data-mp="19vsta0cl3vw">
                <VStack spacing={4} data-id="element-47" data-mp="1941wchp3uby">
                  <Box position="relative" w="full" maxW={{
                  base: '320px',
                  lg: '380px'
                }} mx="auto" borderRadius="xl" overflow="hidden" borderWidth="1px" borderColor="rgba(232, 99, 26, 0.35)" boxShadow="0 0 30px rgba(184, 41, 26, 0.28)" transition="all 0.35s ease" _hover={{
                  borderColor: 'fire.500',
                  boxShadow: '0 0 44px rgba(232, 99, 26, 0.5)'
                }} data-id="element-48" data-mp="3sgyk01g6ra64">
                    <LazyVideo src={videoTestimonial.videoUrl} aspectRatio="9 / 16" label="Reproducir testimonio en video de una clienta" data-id="element-49" data-mp="3lt9rz9h7718s" />
                  </Box>

                  <Text fontSize="sm" color="gold.400" fontWeight="semibold" textAlign="center" data-id="element-50" data-mp="2y3ffwu4pdgpl">
                    Testimonio en video
                  </Text>
                  <Text fontSize="xs" color="gray.400" textAlign="center" maxW="340px" fontStyle="italic" data-id="element-51" data-mp="1k6cree130ymw">
                    Una clienta comparte en sus propias palabras cómo vivió su
                    consulta.
                  </Text>
                </VStack>
              </ScrollReveal>
            </Box>

            {/* Written testimonials */}
            <Box gridColumn={{
            lg: 'span 7'
          }} w="full" data-id="element-52" data-mp="wgiexxkodc36">
              <VStack spacing={5} align="stretch" data-id="element-53" data-mp="sfzp292ceg3m">
                {writtenTestimonials.map((testimonial, index) => <ScrollReveal key={testimonial.name} delay={index * 110} data-id="element-54" data-mp="nhevgshliuo5" data-mpi={index}>
                    <Box as="figure" bg="rgba(10, 10, 10, 0.7)" borderWidth="1px" borderColor="gray.800" borderRadius="xl" p={{
                  base: 5,
                  md: 6
                }} position="relative" transition="all 0.35s ease" _hover={{
                  borderColor: 'rgba(232, 99, 26, 0.5)',
                  transform: 'translateY(-3px)',
                  boxShadow: '0 12px 34px rgba(184, 41, 26, 0.25)'
                }} data-id="element-55" data-mp="ihsi8j1rpefc">
                      <Box as={QuoteIcon} position="absolute" top={4} right={5} boxSize={6} color="rgba(232, 99, 26, 0.25)" aria-hidden="true" data-id="element-56" data-mp="1uto0yidxzm4r" />

                      <HStack spacing={4} align="start" data-id="element-57" data-mp="1pxgumohmw8ma">
                        <Image src={testimonial.photo} alt="" boxSize="56px" htmlWidth="56" htmlHeight="56" borderRadius="full" objectFit="cover" borderWidth="2px" borderColor="fire.500" flexShrink={0} loading="lazy" decoding="async" data-id="element-58" data-mp="3fbdl66mfj778" />
                        <VStack align="start" spacing={2} flex={1} data-id="element-59" data-mp="1rc9ufy30m8vl">
                          <Box data-id="element-60" data-mp="1remf4j05qxcc">
                            <Text fontSize="md" color="white" fontWeight="bold" lineHeight="1.3" data-id="element-61" data-mp="1nbhgirj77fsz">
                              {testimonial.name}
                            </Text>
                            <Text fontSize="xs" color="gold.400" data-id="element-62" data-mp="6xhlnuz7mgcl">
                              {testimonial.location}
                            </Text>
                          </Box>

                          <HStack spacing={1} aria-label="5 de 5 estrellas" data-id="element-63" data-mp="220wesm7qn4e2">
                            {[...Array(5)].map((_, i) => <Box key={i} as={StarIcon} boxSize={3.5} color="gold.400" fill="currentColor" aria-hidden="true" data-id="element-64" data-mp="2711yng7rnmll" data-mpi={i} />)}
                          </HStack>

                          <Text as="blockquote" fontSize="sm" color="gray.300" lineHeight="tall" fontStyle="italic" pr={6} data-id="element-65" data-mp="2pvh1jgx77zep">
                            “{testimonial.quote}”
                          </Text>
                        </VStack>
                      </HStack>
                    </Box>
                  </ScrollReveal>)}
              </VStack>
            </Box>
          </SimpleGrid>

          <Text fontSize="xs" color="gray.500" textAlign="center" maxW="640px" data-id="element-66" data-mp="38u2a6z9dh20o">
            Experiencias compartidas voluntariamente por nuestros clientes. Cada
            proceso es individual y las vivencias pueden variar de una persona a
            otra.
          </Text>
        </VStack>
      </Container>
    </Box>;
}